import styled from 'styled-components';
import imageSource from "./ColorBar.svg.js";
var ColorBar = styled.div.withConfig({
  displayName: "ColorBar",
  componentId: "sc-13gqlkg-0"
})(["height:4px;width:100%;background-image:url(", ");background-repeat:repeat-x;background-size:auto;"], imageSource);
export default ColorBar;
//# sourceMappingURL=ColorBar.js.map